import { render, staticRenderFns } from "./RejectRequisiton.vue?vue&type=template&id=7a189154&scoped=true"
import script from "./RejectRequisiton.vue?vue&type=script&lang=js"
export * from "./RejectRequisiton.vue?vue&type=script&lang=js"
import style0 from "./RejectRequisiton.vue?vue&type=style&index=0&id=7a189154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a189154",
  null
  
)

export default component.exports